// 上传弹窗reducer
import update from 'immutability-helper'

const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'formDataChange': {
            return update(state, {
                formData: {
                    [action.data.field]: {
                        $set: action.data.value,
                    },
                },
                formError: {
                    [action.data.field]: {
                        $set: '',
                    },
                },
            })
        }
        case 'formErrorChange': {
            return update(state, {
                formError: {
                    [action.data.field]: {
                        $set: action.data.value,
                    },
                },
            })
        }
        case 'formErrorReplace': {
            return update(state, {
                formError: {
                    $set: action.data,
                },
            })
        }
        case 'uploadTypeChange': {
            return update(state, {
                uploadType: {
                    $set: action.data,
                },
                formData: {
                    files: {
                        $set: [],
                    },
                    urlFile: {
                        $set: [],
                    },
                },
                formError: {
                    files: {
                        $set: '',
                    },
                    urlFile: {
                        $set: '',
                    },
                },
            })
        }
        case 'stepChange': {
            return update(state, {
                step: {
                    $set: action.data,
                },
            })
        }
        case 'PkgExistStatusReplace': {
            return update(state, {
                pkgExistStatus: {
                    $set: action.data,
                },
            })
        }
        case 'PkgUploadStatusReplace': {
            return update(state, {
                pkgUploadStatus: {
                    $set: action.data,
                },
            })
        }
        case 'PkgExistStatusDelete': {
            return update(state, {
                pkgExistStatus: {
                    [action.data.field]: {
                        $unset: action.data.value,
                    },
                },
            })
        }
        case 'reset': {
            return update(state, {
                formData: {
                    $set: {
                        channelName: '',
                        url: '',
                        files: [],
                        urlFile: null,
                    },
                },
                formError: {
                    $set: {
                        channelName: '',
                        url: '',
                        files: '',
                        urlFile: '',
                    },
                },
                step: { $set: 1 },
                pkgUploadStatus: {
                    $set: {
                        successRecords: [],
                        failedRecords: [],
                    },
                },
                uploadType: { $set: 'LOCAL_UPLOAD' },
                csvFileData: {
                    $set: {},
                },
            })
        }
        case 'csvFileDataChange': {
            return update(state, {
                csvFileData: {
                    $set: action.data,
                },
            })
        }
        default:
            return state
    }
}

export default reducer
